import { Macro } from "@/types/lighthouse";

export const macros: Macro[] = [
  {
    id: "vlookup",
    name: "Vlookup",
    category: "Excel Formula",
    description: "Demonstrates how to use the Vlookup Example function in Excel.",
    fullDescription:
      "Demonstrates how to use the VLOOKUP function to retrieve a region based on a sales ID from a dataset. The example shows how VLOOKUP can help locate associated values from a reference table, ideal for matching identifiers to attributes like locations or names.",
  },
  {
    id: "avgifs-single-criteria",
    name: "Avgifs Single Criteria",
    category: "Excel Formula",
    description: "Demonstrates how to use the Avgifs Single Criteria Example function in Excel.",
    fullDescription:
      "Illustrates the use of the AVERAGEIFS function to calculate the average sales amount for a specific salesperson. This example filters the dataset by a single criterion (e.g., salesperson name) to compute an average, useful for performance tracking and benchmarking.",
  },
  {
    id: "avgifs-multi.-criteria",
    name: "Avgifs Multi. Criteria",
    category: "Excel Formula",
    description: "Demonstrates how to use the Avgifs Multi. Criteria Example function in Excel.",
    fullDescription:
      "Shows how to apply the AVERAGEIFS function with multiple criteria — such as salesperson name and sales month — to derive more refined insights. It's helpful when comparing performance over specific time periods or scenarios.",
  },
  {
    id: "sumifs-single-criteria",
    name: "Sumifs Single Criteria ",
    category: "Excel Formula",
    description: "Demonstrates how to use the Sumifs Single Criteria Example function in Excel.",
    fullDescription:
      "Demonstrates how to use the SUMIFS function to add up sales figures filtered by one condition, like salesperson name. This is useful for quickly calculating total contributions or tracking metrics by a single attribute.",
  },
  {
    id: "sumifs-multi.-criteria",
    name: "Sumifs Multi. Criteria",
    category: "Excel Formula",
    description: "Demonstrates how to use the Sumifs Multi. Criteria Example function in Excel.",
    fullDescription:
      "Highlights how to sum data using the SUMIFS function with multiple filters, such as salesperson and month. This allows for deeper analysis, like reviewing performance over a specific time window or condition.",
  },
  {
    id: "index-match",
    name: "Index Match",
    category: "Excel Formula",
    description: "Demonstrates how to use the Index Match Example function in Excel.",
    fullDescription:
      "Presents the INDEX and MATCH formula combination as a flexible alternative to VLOOKUP. The example locates a sales amount by matching a sales ID, ideal when column positions are variable or performance matters.",
  },
];
